import React from 'react';
import { Box, BoxProps } from '@mui/material';

/**
 * Text that keeps its size on a phone.
 *
 * global.css forces `.MuiTypography-body1/body2` to a fixed size (plus a bottom
 * margin) with `!important` on small screens, which overrides any size set in
 * `sx` — so a layout tuned on desktop comes out oversized and cramped on a
 * phone. A plain Box is not a Typography, so it keeps the size it is given on
 * every screen. Takes the same `sx` a Typography would.
 *
 * Use it for any dense, precisely-sized layout (exercise screens, chart cards,
 * tooltips) that must look the same on phone and desktop.
 */
const Txt = React.forwardRef<HTMLDivElement, BoxProps>(({ sx, ...rest }, ref) => (
  <Box ref={ref} {...rest} sx={{ m: 0, lineHeight: 1.4, ...(sx as object) }} />
));
Txt.displayName = 'Txt';

export default Txt;
